<template>
  <div class="fixed_nav_w">
    <!-- 账户 -->
    <div
      class="account_nav"
      @mouseenter="onAccountEnter(0)"
      @mouseleave="ononAccountLeave"
    >
      <div
        class="nav_i x_y_center flex_direction_col"
        :class="isActive(0) ? 'is_active' : ''"
        @click="onAccountClick"
      >
        <img
          :src="
            require(`@/assets/images/${
              isActive(0) ? 'fixed_1.png' : 'fixed_5.png'
            }`)
          "
          alt=""
        />
        <span class="span_1 fz14">账户</span>
      </div>

      <router-link
        to="/login"
        v-if="isActive(0) && !isLogin"
        class="go_login fz12 c_fff text_center cursor_pointer"
      >
        <div class="div_1" @mouseleave="ononAccountLeave">点我登录</div>
      </router-link>
    </div>
    <!-- 客服 -->
    <el-popover
      title=""
      trigger="hover"
      placement="left"
      :content="'客服热线：' + siteInfo.hotline"
    >
      <div slot="reference">
        <div
          class="nav_i x_y_center flex_direction_col"
          :class="isActive(1) ? 'is_active' : ''"
          @mouseenter="onNavEnter(1)"
          @mouseleave="onNavLeave"
        >
          <img
            :src="
              require(`@/assets/images/${
                isActive(1) ? 'fixed_6.png' : 'fixed_2.png'
              }`)
            "
            alt=""
          />
          <span class="span_1 fz14">客服</span>
        </div>
      </div>
    </el-popover>

    <!-- 大屏 -->
    <div @mouseenter="onNavEnter(3)" @mouseleave="onNavLeave">
      <router-link
        to="/bigdata"
        class="nav_i x_y_center flex_direction_col"
        target="_blank"
        :class="isActive(3) ? 'is_active' : ''"
      >
        <img
          :src="
            require(`@/assets/images/${
              isActive(3) ? 'fixed_10.png' : 'fixed_9.png'
            }`)
          "
          alt=""
        />
        <span class="span_1 fz14">大屏</span>
      </router-link>
    </div>

    <!-- 回到顶部 -->
    <div @mouseenter="onNavEnter(5)" @mouseleave="onNavLeave">
      <div
        class="nav_i x_y_center flex_direction_col"
        :class="isActive(5) ? 'is_active' : ''"
        @click="onGoTop"
        style="border-bottom: 1px solid #e6e6e6;"
      >
        <img
          :src="
            require(`@/assets/images/${
              isActive(5) ? 'fixed_8.png' : 'fixed_4.png'
            }`)
          "
          alt=""
        />
        <span class="span_1 fz14">回到顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      navItemIndex: -1,
      accountTimer: null,
    };
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "siteInfo",
      "cmsProblemNode",

    ]),

    isActive() {
      return function (index) {
        return this.navItemIndex === index;
      };
    },
    isHome() {
      return this.$route.path === "/home";
    },


  },
  created() {

  },
  methods: {


    // 账户点击 click
    onAccountClick() {
      if (this.isLogin) {
        this.$router.push("/account/setting");
      }
    },
    // 导航项移入
    onNavEnter(index) {
      this.navItemIndex = index;
    },
    // 导航项移出
    onNavLeave() {
      this.navItemIndex = -1;
    },
    // 回到顶部
    onGoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.$router.push(this.$route.fullPath.replace(/#.*/, ""));
    },
    // 账户移入
    onAccountEnter(index) {
      this.accountTimer && clearTimeout(this.accountTimer);

      this.accountTimer = setTimeout(() => {
        this.navItemIndex = index;
      }, 100);
    },
    // 账户移出
    ononAccountLeave() {
      this.accountTimer && clearTimeout(this.accountTimer);
      this.accountTimer = setTimeout(() => {
        this.navItemIndex = -1;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed_nav_w {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 999;

  .nav_i {
    width: 65px;
    height: 70px;
    border-top: 1px solid #e6e6e6;
    border-left: 1px solid #e6e6e6;
    border-right: 1px solid #e6e6e6;
    background-color: #fff;
    color: #1a1a1a;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      border-color: #0983cc;
    }
  }





  .is_active {
    background-color: #0983cc;

    color: #fff;
  }
  .account_nav {
    position: relative;

    .go_login {
      position: absolute;
      left: -100px;
      top: 15px;
      width: 89px;
      height: 40px;
      line-height: 40px;
      background-color: #4d4d4d;

      &::before {
        content: "";
        position: absolute;
        right: -14px;
        top: 50%;
        transform: translateY(-50%);
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 7px solid #4d4d4d;
        border-right: 7px solid transparent;
      }
    }
  }
  .span_1 {
    margin: 8px 0 0 0;
  }
  .div_1 {
    height: 100%;
  }
}
</style>
